import type { ComponentProps, ReactNode } from 'react';
import { TopBar } from '../organisms';

type AppTemplateProps = ComponentProps<typeof TopBar> & { children: ReactNode };

/** Signed-in frame: the navigation row opens the band that each page continues. */
export function AppTemplate({ children, ...topBar }: AppTemplateProps) {
  return (
    <>
      <header className="bg-band">
        <div className="mx-auto max-w-[1360px] px-4 sm:px-8">
          <TopBar {...topBar} />
        </div>
      </header>
      <main>{children}</main>
    </>
  );
}
